import * as saveProductConfiguration from 'store/actions/products/configuration/saveConfiguration';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* saveProductConfigurationAsync({ payload }) {
    const { id, configuration, onSuccess, onError } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/products/${ id }`;

        const response = yield apiClient.patch(url, { configuration: configuration });

        yield put(saveProductConfiguration.saveProductConfigurationSuccess(payload, response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess(response);
        }
    } catch (error) {
        yield put(saveProductConfiguration.saveProductConfigurationFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

function* saveProductConfigurationSuccessAsync() {
    yield put(showNotification('resources.products.configuration.saved'));
}

export default function* productConfigurationSagas() {
    yield [
        takeEvery(types.SAVE_PRODUCT_CONFIGURATON, saveProductConfigurationAsync),
        takeEvery(types.SAVE_PRODUCT_CONFIGURATON_FAILURE, failureMessage),
        takeEvery(types.SAVE_PRODUCT_CONFIGURATON_SUCCESS, saveProductConfigurationSuccessAsync),
    ];
}


// WEBPACK FOOTER //
// ./src/store/sagas/productConfigurationSagas.js